import BaseIntegration from '@/common/mixins/integrations/baseIntegration';

const IraqZainIntegrationMixin = {
  extends: BaseIntegration,
  methods: {
    getIntegrationParametersCheckImpl() {
      return (to) => {
        const userMsisdn = to.query.msisdn;
        const hash = to.query.msisdnencrypted;
        const correlationId = to.query.uniqid;
        const status = to.query.success;
        if (userMsisdn && hash) { // 3G case
          this.SHOW_LOADING = true;
          this.$axios.get(`api/getStatus?msisdn=${userMsisdn}&hashedMsisdn=${hash}&lang=${this.getLocale}&correlationId=${correlationId}&status=${status}`).then((res) => {
            this.SHOW_LOADING = false;
            if (res.data.responseEnum === 'OPERATION_SUCCESS' && res.data.data) {
              const hasSub = res.data.data.isSub;
              if (hasSub === 'true') {
                this.$gtm.trackEvent({
                  event: 'CompleteRegistration',
                  category: 'MSISDN Registration',
                  action: 'Register 2 registration',
                  label: 'Register 2',
                });
              }
              this.storeLoginInfo({
                token: res.data.data.user_auth_token,
                rememberMeParameter: false,
                username: res.data.data.username,
              });
              this.getUserLoginDetails().then(() => {
                this.updateUserLanguage();
                this.$router.push('home');
              });
            }
          });
        } else if (correlationId) { // wifi case
          this.$router.push('register1');
        } else {
          this.proceedToAutoLogin(to); // check for autologin request
        }
      };
    },
  },
};

export default IraqZainIntegrationMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/integrations/iraqZainIntegration.js